import { IconProps } from "../../utils/global-types/global-types";

const TemplatesIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className ? className : "w-[18px] h-[18px]"}
      {...rest}
    >
      <g clipPath="url(#clip0_9957_107092)">
        <path
          d="M11.168 5.89453C10.6026 5.89453 10.1426 5.43454 10.1426 4.86914V1.5H4.89844C4.00995 1.5 3.28711 2.22284 3.28711 3.11133V14.8887C3.28711 15.7772 4.00995 16.5 4.89844 16.5H13.1016C13.99 16.5 14.7129 15.7772 14.7129 14.8887V5.89453H11.168ZM5.68945 12.0469H7.81992C8.06262 12.0469 8.25938 12.2436 8.25938 12.4863C8.25938 12.729 8.06262 12.9258 7.81992 12.9258H5.68945C5.44676 12.9258 5.25 12.729 5.25 12.4863C5.25 12.2436 5.44676 12.0469 5.68945 12.0469ZM5.25 10.1426C5.25 9.89988 5.44676 9.70312 5.68945 9.70312H12.1348C12.3775 9.70312 12.5742 9.89988 12.5742 10.1426C12.5742 10.3853 12.3775 10.582 12.1348 10.582H5.68945C5.44676 10.582 5.25 10.3853 5.25 10.1426ZM12.1348 7.35938C12.3775 7.35938 12.5742 7.55613 12.5742 7.79883C12.5742 8.04152 12.3775 8.23828 12.1348 8.23828H5.68945C5.44676 8.23828 5.25 8.04152 5.25 7.79883C5.25 7.55613 5.44676 7.35938 5.68945 7.35938H12.1348Z"
          fill="currentColor"
        />
        <path
          d="M11.0215 4.86914C11.0215 4.94991 11.0872 5.01563 11.168 5.01563H14.517C14.4366 4.86721 14.3332 4.73089 14.209 4.61332L11.3841 1.9408C11.2744 1.83709 11.1523 1.75058 11.0215 1.68226V4.86914H11.0215Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_9957_107092">
          <rect
            width="15"
            height="15"
            fill="white"
            transform="translate(1.5 1.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default TemplatesIcon;
